import { render, staticRenderFns } from "./WorkflowPrepProcessAdd.vue?vue&type=template&id=47ec4978"
import script from "./WorkflowPrepProcessAdd.vue?vue&type=script&lang=js"
export * from "./WorkflowPrepProcessAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports